import { ConfigModel } from '../models/config.model';
import { statusPageOptions } from '../models/status-page-options';
import { apps } from './apps.factory';

export function getConfig(): ConfigModel {
  // Todo: Developer Platform: "Try it" API mit App-Credentials https://dev.azure.com/techgroup/Maison%20du%20Software/_workitems/edit/46257
  const origin = globalThis.location.origin;
  if (/localhost:4200|127\.0\.0\.1:4200/.test(origin)) {
    return getDev();
  }
  if (/dev.developers.planzer.app/.test(origin)) {
    return getDev();
  }

  if (/at.developers.planzer.app/.test(origin)) {
    return getAt();
  }

  if (/uat.developers.planzer.app/.test(origin)) {
    return getUat();
  }

  if (/developers.app.planzer.ch/.test(origin)) {
    return getProd();
  }

  throw Error('Environment url is not supported');
}

function getDev(): ConfigModel {
  const serverUrl = 'https://dev.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      issuer: 'https://dev.id.planzer.app',
    },
    statusPageUrl: statusPageOptions.nonProduction,
    appInsights: {
      connectionString:
        'InstrumentationKey=6c2255a4-6b3e-4024-bf42-b6235394a5ce;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/',
    },
    apps: apps,
  };
}

function getAt(): ConfigModel {
  const serverUrl = 'https://at.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      issuer: 'https://at.id.planzer.app',
    },
    statusPageUrl: statusPageOptions.nonProduction,
    appInsights: {
      connectionString:
        'InstrumentationKey=8b6efed2-a8f9-465a-9f1c-67b7f7e4f6cb;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=11b345ee-f082-444e-9f32-82c44a89a255',
    },
    apps: apps,
  };
}

function getUat(): ConfigModel {
  const serverUrl = 'https://uat.api.planzer.app';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      issuer: 'https://uat.id.planzer.app',
    },
    statusPageUrl: statusPageOptions.nonProduction,
    appInsights: {
      connectionString:
        'InstrumentationKey=e0d70dc5-a517-4d1c-890f-194c1d205858;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=81bcf13b-9c48-43e1-afec-f2354cb3e45b',
    },
    apps: apps,
  };
}

function getProd(): ConfigModel {
  const serverUrl = 'https://api.app.planzer.ch';
  prefixServerUrl(serverUrl);

  return {
    authConfig: {
      issuer: 'https://id.planzer.ch',
    },
    statusPageUrl: statusPageOptions.production,
    appInsights: {
      connectionString:
        'InstrumentationKey=350b838e-f665-41e6-801c-644f58ba4bd6;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=5d9f0df1-b989-4132-a1c7-f95457f1332e',
    },
    apps: apps,
  };
}

function prefixServerUrl(serverUrl: string): void {
  apps.forEach((app) => {
    app.openApiUrl = `${serverUrl}${app.openApiUrl}`;
    app.serverUrl = `${serverUrl}${app.serverUrl}`;
  });
}
